<template>
  <div>
    <div>
      <div
        class="col-12 d-flex flex-wrap filter-row"
      >
        <el-select
          class="select-primary pagination-select"
          v-model="pagination.perPage"
          :placeholder="$t('COMMON.PER_PAGE')"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <organization-selector
          v-if="
            !filterOrganization &&
            !filterIssuer &&
            !filterPurchasesOrder &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
          @organizationChanged="
            (organizationId) => (selectedOrganization = organizationId)
          "
        />

        <base-input
          v-if="
            !filterEstablishment &&
            !filterPurchasesOrder &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ESTABLISHMENTS)
          "
        >
          <establishment-selector
            :establishment="selectedEstablishment"
            :filterOrganization="selectedOrganization || filterOrganization"
            :showAll="true"
            @establishmentChanged="
              (establishmentId) => (selectedEstablishment = establishmentId)
            "
          />
        </base-input>

        <base-input
          v-if="!filterIssuer && !filterPurchasesOrder"
        >
          <supplier-selector
            :supplier="selectedSupplierId"
            :filterOrganization="selectedOrganization || filterOrganization"
            :showAll="true"
            @supplierChanged="
              (supplierId) => (selectedSupplierId = supplierId)
            "
          />
        </base-input>
      </div>
      <div
        class="col-12 d-flex flex-wrap filter-row"
      >
        <el-select
          v-if="!filterStatus"
          :placeholder="$t('COMMON.STATUS')"
          v-model="selectedStatus"
        >
          <el-option :value="0" :label="$t('COMMON.ALL_STATUSES')"> </el-option>
          <el-option
            v-for="(value, key) in statusesOptions"
            :key="key"
            :value="key"
            :label="value"
          >
          </el-option>
        </el-select>

        <base-input class="dates" :placeholder="$t('COMMON.DATES_PLACEHOLDER')">
          <flat-picker
            :config="{
              allowInput: true,
              mode: 'range',
              locale: $flatPickrLocale(),
            }"
            class="form-control datepicker"
            v-model="dateRange"
            :placeholder="$t('COMMON.DATES_PLACEHOLDER')"
          >
          </flat-picker>
        </base-input>

        <div class="code">
          <base-input
            v-model="query"
            type="search"
            prepend-icon="fas fa-search"
            :placeholder="$t('COMMON.SEARCH_HINT.DOCUMENT')"
            clearable
          />
        </div>
      </div>
      <el-table
        class="align-items-center table-flush"
        header-row-class-name="thead-light"
        :data="purchasesInvoices"
        @sort-change="sortChange"
      >
        <div slot="empty" v-if="loading">
          <img src="/img/loading.gif" style="height: 100px; width: 100px" />
        </div>
        <el-table-column
          :label="$t('COMMON.NUMBER')"
          min-width="250px"
          sortable="custom"
          prop="seq_number"
        >
          <template slot-scope="{ row }">
            {{ row.seq_number ?? row.code }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.STATUS')"
          prop="status"
          min-width="150px"
        >
          <template slot-scope="{ row }">
            <purchases-invoice-status-badge :purchasesInvoice="row" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.AMOUNT')"
          prop="pricing.total"
          min-width="200px"
        >
          <template v-slot="{ row }">
            <span>
              {{ $formatCurrency(row.pricing.total) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.ESTABLISHMENT')"
          v-if="
            !filterEstablishment &&
            !filterPurchasesOrder &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ESTABLISHMENTS)
          "
          min-width="250px"
        >
          <template v-slot="{ row }">
            <object-link :object="row.establishment" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('COMMON.SUPPLIER')" min-width="250px">
          <template v-slot="{ row }">
            <object-link :object="row.issuer" />
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.ORGANIZATION')"
          v-if="
            !filterOrganization &&
            !filterPurchasesOrder &&
            $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
          "
          min-width="250px"
        >
          <template v-slot="{ row }">
            <organization :organization="row.organization" />
          </template>
        </el-table-column>
        <!-- <el-table-column
          :label="$t('PURCHASES_INVOICES.EXPIRATION_TIME')"
          prop="expiration_time"
          sortable="custom"
          min-width="250px"
        /> -->
        <el-table-column
          :label="$t('INVOICES.INVOICING_DATE')"
          prop="invoicing_date"
          sortable="custom"
          min-width="220px"
        >
          <template v-slot="{ row }">
            {{ $timeZoneDateFormat(row.invoicing_date) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('COMMON.CREATED_AT')"
          prop="created_at"
          sortable="custom"
          min-width="200px"
        >
          <template v-slot="{ row }">
            {{ $timeZoneDateFormat(row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column min-width="100px" align="center" fixed="right">
          <div slot-scope="{ row }" class="table-actions">
            <el-tooltip
              :content="$t('COMMON.VIEW')"
              placement="top"
              v-if="$currentUserCan($permissions.PERM_VIEW_PURCHASES_INVOICES)"
            >
              <a
                type="text"
                @click="viewPurchasesInvoice(row)"
                class="table-action"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-eye"></i>
              </a>
            </el-tooltip>

            <el-tooltip
              :content="$t('COMMON.EDIT')"
              placement="top"
              v-if="
                $currentUserCan($permissions.PERM_EDIT_PURCHASES_INVOICES) &&
                row.status == INVOICE_STATUS_DRAFT
              "
            >
              <a
                type="text"
                @click="editPurchasesInvoice(row)"
                class="table-action"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-edit"></i>
              </a>
            </el-tooltip>

            <el-tooltip
              :content="$t('COMMON.DELETE')"
              placement="top"
              v-if="
                $currentUserCan($permissions.PERM_DELETE_PURCHASES_INVOICES) &&
                row.status == INVOICE_STATUS_DRAFT
              "
            >
              <a
                type="text"
                @click="deletePurchasesInvoice(row.id)"
                class="table-action table-action-delete"
                data-toggle="tooltip"
                style="cursor: pointer"
              >
                <i class="fas fa-trash"></i>
              </a>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="mt-5 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap table-footer"
    >
      <div class="">
        <p class="card-category">
          {{
            $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
              from: total ? from + 1 : 0,
              to: to,
              of: total,
            })
          }}

          <span v-if="selectedRows.length">
            &nbsp; &nbsp;
            {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
          </span>
        </p>
      </div>
      <base-pagination
        class="pagination-no-binvoice"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import moment from "moment";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  invoiceStatusesOption,
  INVOICE_STATUS_DRAFT,
} from "@/constants/invoices";
import { BasePagination } from "@/components";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import EstablishmentSelector from "@/components/EstablishmentSelector.vue";
import SupplierSelector from "@/components/SupplierSelector.vue";
import PurchasesInvoiceStatusBadge from "./PurchasesInvoiceStatusBadge.vue";

export default {
  name: "purchases-invoice-list-table",

  components: {
    BasePagination,
    flatPicker,
    OrganizationSelector,
    EstablishmentSelector,
    SupplierSelector,
    PurchasesInvoiceStatusBadge,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "Organization id",
    },
    filterPurchasesOrder: {
      type: String,
      default: null,
      description: "Order id",
    },
    filterIssuer: {
      type: Object,
      default: null,
      description: "Object with 'issuer_id' and 'issuer_type' ",
    },
    filterStatus: {
      type: String,
      default: null,
      description: "Status",
    },
    filterServiceCenter: {
      type: String,
      default: null,
      description: "Service center id",
    },
    filterEstablishment: {
      type: String,
      default: null,
      description: "Establishment id",
    },
    filterCafeteria: {
      type: String,
      default: null,
      description: "Cafeteria id",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-invoicing_date",
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [20, 50, 100, 500],
      },
      purchasesInvoices: [],
      loading: true,
      dateRange: null,
      selectedOrganization: null,
      selectedEstablishment: null,
      selectedSupplierId: null,
      selectedStatus: null,
      selectedIssuer: null,
      statusesOptions: invoiceStatusesOption,
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedEstablishment: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedSupplierId: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterIssuer: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedIssuer: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterPurchasesOrder: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterStatus: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedStatus: {
      handler: "getListDebounced",
      immediate: true,
    },
    dateRange: {
      handler: "getListDebounced",
      immediate: false,
      deep: true,
    },
    filterServiceCenter: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterEstablishment: {
      handler: "getListDebounced",
      immediate: true,
    },
    filterCafeteria: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      try {
        const vDateRange = this.dateRange
          ? this.dateRange.split(this.$flatPickrLocale().rangeSeparator)
          : [];
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: encodeURIComponent(this.query) } : {}),
            ...(vDateRange.length == 2
              ? {
                  invoicing_date: [
                    this.$getUtcDateTimeString(
                      moment(vDateRange[0]).startOf("day").toISOString()
                    ),
                    this.$getUtcDateTimeString(
                      moment(vDateRange[1]).endOf("day").toISOString()
                    ),
                  ],
                }
              : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization,establishment,issuer",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.filterPurchasesOrder) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              purchasesOrder: this.filterPurchasesOrder,
            },
          };
        }
        if (this.selectedOrganization) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              organization: this.selectedOrganization,
            },
          };
        }
        if (this.filterIssuer) {
          if (this.filterIssuer.type && this.filterIssuer.id) {
            params = {
              ...params,
              filter: {
                ...params.filter,
                issuer_type: this.filterIssuer.type,
                issuer_id: this.filterIssuer.id,
              },
            };
          }
        }
        if (this.selectedIssuer) {
          if (this.selectedIssuer.type && this.selectedIssuer.id) {
            params = {
              ...params,
              filter: {
                ...params.filter,
                issuer_type: this.selectedIssuer.type,
                issuer_id: this.selectedIssuer.id,
              },
            };
          }
        }
        if (this.filterStatus) {
          params = {
            ...params,
            filter: { ...params.filter, status: this.filterStatus },
          };
        }
        if (this.selectedStatus) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              status: this.selectedStatus,
            },
          };
        }
        if (this.selectedEstablishment) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              establishment: this.selectedEstablishment,
            },
          };
        }
        if (this.selectedSupplierId) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              issuer_type: "suppliers",
              issuer_id: this.selectedSupplierId,
            },
          };
        }
        if (this.filterServiceCenter) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              serviceCenter: this.filterServiceCenter,
            },
          };
        }
        if (this.filterEstablishment) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              establishment: this.filterEstablishment,
            },
          };
        }
        if (this.filterCafeteria) {
          params = {
            ...params,
            filter: { ...params.filter, cafeteria: this.filterCafeteria },
          };
        }

        await this.$store.dispatch("purchasesInvoices/list", params);
        this.purchasesInvoices = this.$store.getters["purchasesInvoices/list"];
        this.total = this.$store.getters["purchasesInvoices/listTotal"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async deletePurchasesInvoice(id) {
      const confirmation = await swal.fire({
        title: this.$t("PURCHASES_INVOICES.DELETE_THIS_PURCHASES_INVOICE"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("purchasesInvoices/destroy", id);
          await this.getList();
          this.$notify({
            type: "success",
            message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    viewPurchasesInvoice(purchasesInvoice) {
      this.$router.push({
        name: "View PurchasesInvoice",
        params: { id: purchasesInvoice.id },
      });
    },

    async editPurchasesInvoice(row) {
      this.$router.push({
        name: "Edit PurchasesInvoice",
        params: { id: row.id },
      });
    },

    sortChange({ prop, order }) {
      if (!order) {
        this.sort = "-invoicing_date";
        this.getList();
        return;
      }
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
